import { render, staticRenderFns } from "./WaitingListAddToQueueSidebar.vue?vue&type=template&id=7ba3c838&"
import script from "./WaitingListAddToQueueSidebar.vue?vue&type=script&lang=js&"
export * from "./WaitingListAddToQueueSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WaitingListAddToQueueSidebar.vue?vue&type=style&index=0&id=7ba3c838&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports